import { Separator } from '@qr-front/ui/components/Separator'
import { useAtomValue } from 'jotai'
import { useTranslations } from 'next-intl'

import { SharedWeekDays } from './SharedWeekDays'
import { selectedTabAtom } from './TabNavigation'
import { WeekDays } from './WeekDays'

export const OpeningHoursFields = () => {
	const t = useTranslations()
	const selectedTab = useAtomValue(selectedTabAtom)

	if (selectedTab === 'open-24h') return null

	return (
		<div className="flex flex-col gap-2">
			<SharedWeekDays />
			<div className="my-4 flex w-full items-center gap-4 desktop:my-6">
				<Separator collapse={false} className="w-full" />
				<p className="type-body-medium text-grey">
					{t('generator__content_form_section__opening_hours__or_separator')}
				</p>
				<Separator collapse={false} className="w-full" />
			</div>
			<WeekDays />
		</div>
	)
}
